import React, { useEffect, useState } from "react";
import { Row, Table, Tooltip } from "antd";
import { useDispatch, useSelector } from "react-redux";
import "../../../assets/style/table/deals.scss";
import { groupNotificationSelector } from "../../../services/selector/index.";
import {
  IconDetail,
  IconEdit,
  IconLock,
  IconNext,
  IconPre,
  IconSpin,
  IconXmark,
} from "../../../assets/icon";
import { useMemo } from "react";
import { setOpenPUDelete } from "../../../services/slice/PopUpSlice";
import TranslateText from "../TranslateText";
import { renameTypeDeal } from "../../../utils/convertNumber";
import { useTranslation } from "react-i18next";
import { formatDate } from "../../../utils/functionCommon";
import HeaderChatBkavPro from "../HeaderChatBkavPro";
import {
  getGroupNotify,
  getLogGroupNotify,
  setOpenDetailGroupNotification,
  setOpenEditGroupNotification,
  setOpenModalGetLogGroupNotification,
  setOpenModalPostGroupNotification,
} from "../../../services/slice/GroupNotificationSlice";
import moment from "moment";
import NoSearchResults from "../NoSearchResults";
const dateFormat = "YYYY-MM-DDTHH:mm:ss";

const TableGroupNotifycation = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const groupNotifyState = useSelector(groupNotificationSelector);
  const { dataGroupNotify, isLoading, callBackRequest } = groupNotifyState;
  const content = dataGroupNotify?.content;
  const total = dataGroupNotify?.totalElements;
  const [config, setConfig] = useState({
    timeStart: moment().subtract(3, "month").startOf("day").format(dateFormat),
    timeEnd: moment().endOf("day").format(dateFormat),
    size: 10,
    page: 0,
    search: "",
  });
  useEffect(() => {
    dispatch(
      getGroupNotify({
        timeStart: new Date(config.timeStart).getTime() / 1000,
        timeEnd: new Date(config.timeEnd).getTime() / 1000,
        size: config.size,
        page: config.page,
        search: config.search,
      })
    );
  }, [dispatch, config]);
  useEffect(() => {
    if (callBackRequest) {
      dispatch(
        getGroupNotify({
          timeStart: new Date(config.timeStart).getTime() / 1000,
          timeEnd: new Date(config.timeEnd).getTime() / 1000,
          size: config.size,
          page: config.page,
          search: config.search,
        })
      );
    }
  }, [dispatch, callBackRequest]);

  const dataSource = useMemo(() => {
    let result = [];
    result = content?.map((item, index) => {
      return {
        ...item,
        STT: config.page * config.size + index + 1,
        status: t(renameTypeDeal(item.status)),
        timeStart: formatDate(item.startTime),
        timeEnd: formatDate(item.endTime),
        timeCreate: formatDate(item.createdAt),
      };
    });
    return result;
  }, [content, t, total]);

  const columns = [
    {
      title: "STT",
      dataIndex: "STT",
      key: "STT",
      className: "centerCell",
      width: 60,
    },
    {
      title: <TranslateText text="Tiêu đề" />,
      dataIndex: "title",
      key: "title",
      className: "title pointer",
      ellipsis: {
        showTitle: false,
      },
      render: (value) => (
        <Tooltip placement="topLeft" title={value}>
          <div style={{ paddingLeft: 6 }}>{value}</div>
        </Tooltip>
      ),
    },
    {
      title: <TranslateText text="Đối tượng" />,
      dataIndex: "typePreferential",
      key: "typePreferential",
      className: "limit centerCell",
      render: (text, record) => {
        if (text === 0) {
          return "Toàn bộ KH";
        } else if (text === 1) return "KH thuộc đại lý";
        else return "KH Online";
      },
    },
    {
      title: <TranslateText text="Thời gian bắt đầu KM" />,
      dataIndex: "timeStart",
      key: "timeStart",
      className: "centerCell",
    },
    {
      title: <TranslateText text="Thời gian kết thúc KM" />,
      dataIndex: "timeEnd",
      key: "timeEnd",
      className: "centerCell",
    },

    {
      title: <TranslateText text="Trạng thái" />,
      key: "status",
      dataIndex: "status",
      className: "centerCell",
    },
    {
      title: <TranslateText text="Thời gian tạo" />,
      dataIndex: "timeCreate",
      key: "timeCreate",
      className: "centerCell",
    },
    {
      title: <TranslateText text="Chức năng" />,
      key: "action",
      dataIndex: "action",
      className: "evenSpace",
      render: (text, record) => {
        return (
          <div className="evenSpace" style={{ minWidth: "120px" }}>
            <span
              className="pointer iconTbl"
              onClick={() => {
                dispatch(getLogGroupNotify(record.id));
                dispatch(setOpenModalGetLogGroupNotification(true));
              }}
            >
              <Tooltip title="Xem log">
                <IconLock />
              </Tooltip>
            </span>
            <span
              className="pointer iconTbl"
              onClick={() =>
                dispatch(
                  setOpenDetailGroupNotification({
                    isOpen: true,
                    id: record.id,
                  })
                )
              }
            >
              <Tooltip title="Xem chi tiết">
                <IconDetail />
              </Tooltip>
            </span>

            {(record.status === "Chưa diễn ra" ||
              record.status === "Kết thúc") && (
              <span
                className="pointer iconTbl"
                onClick={() =>
                  dispatch(
                    setOpenEditGroupNotification({
                      isOpen: true,
                      id: record.id,
                    })
                  )
                }
              >
                <Tooltip title="Chỉnh sửa">
                  <IconEdit />
                </Tooltip>
              </span>
            )}
            <span
              className="pointer iconTbl"
              onClick={() =>
                dispatch(
                  setOpenPUDelete({
                    stateOpen: true,
                    content: record.title,
                    id: record.id,
                  })
                )
              }
            >
              <Tooltip title="Xóa">
                <IconXmark />
              </Tooltip>
            </span>
          </div>
        );
      },
    },
  ];
  const tableLoading = {
    spinning: isLoading, // isLoading là biến boolean để xác định xem có đang loading hay không
    indicator: <IconSpin className="iconSpin" />,
  };
  return (
    <div style={{ width: "100%" }}>
      <HeaderChatBkavPro
        config={config}
        setConfig={setConfig}
        handleClick={() => {
          dispatch(setOpenModalPostGroupNotification(true));
        }}
      />
      {config.search && content.length <= 0 ? (
        <Row style={{ width: "100%" }}>
          <NoSearchResults />
        </Row>
      ) : (
        <Row style={{ width: "100%" }}>
          <Table
            loading={tableLoading}
            className="wrapperTblNewsPost"
            style={{ width: "100%", marginTop: "2.6rem" }}
            columns={columns}
            dataSource={dataSource}
            pagination={
              total > 10
                ? {
                    onChange: (page) => {
                      setConfig((prev) => ({
                        ...prev,
                        page: page - 1,
                      }));
                    },
                    current: config.page + 1,
                    total: total,
                    pageSize: 10,
                    prevIcon: <IconPre />,
                    nextIcon: <IconNext />,
                    showSizeChanger: false,
                  }
                : false
            }
          />
        </Row>
      )}
    </div>
  );
};

export default TableGroupNotifycation;
